import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import _ from 'static/script/libs/underscore';
import RecentlyViewedItemsStorage from 'static/script/app/models/recently-viewed-items-storage';
import JST from 'static/script/templates/templates';

function RecentlyViewedItems() {
    this._recentlyViewedItemsStorage = new RecentlyViewedItemsStorage();

    this.defaultAttrs({
        recentlyViewItemsList: 'ul',
        recentListTemplate: '[data-recently-viewed-items-list-template]',
        recentlyItemsClearButton: '[data-recently-viewed-clear]'
    });

    this._loadRecentlyViewItems = function() {
        let itemList = this._getItemsFromStorage();
        if (itemList.length === 0) {
            this.$node.html('');
            return;
        }
        this._renderItems(itemList);
    };

    this._getItemsFromStorage = function() {
        let items = this._recentlyViewedItemsStorage.getAllItems();
        _.each(items, function(item) {
            item.imageUrl = item.imageUrl.replace(
                /\/listthumb\//gi,
                '/preview/'
            );
        });

        return items;
    };

    this._renderItems = function(itemList) {
        let template =
            JST['templates/recently-viewed-items-list-template.html'];

        if (!template) {
            return;
        }
        let listHtml = template({ itemList: itemList });

        this.$node.html(listHtml);
        this.trigger(document, 'ui:recently-viewed-items:on-items-change');
    };

    this._clearItems = function() {
        this._recentlyViewedItemsStorage.clearItems();
        this.$node.fadeOut(
            'fast',
            function() {
                this.$node.remove();
            }.bind(this)
        );
        this.trigger(document, 'ui:recently-viewed-items:on-items-change');
    };

    this.after('initialize', function() {
        if (
            document.readyState &&
            (document.readyState === 'complete' ||
                document.readyState.state === 'complete')
        ) {
            this._loadRecentlyViewItems();
        } else {
            $(window).on('load', this._loadRecentlyViewItems.bind(this));
        }

        this.on('click', {
            recentlyItemsClearButton: this._clearItems
        });

        this.on(
            document,
            'ui:navigation:after-page-change',
            this._loadRecentlyViewItems
        );
    });
}

export default defineComponent.component(RecentlyViewedItems);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/recently-viewed-items.js